/**
 * Spacer Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initSpacer() {
        const blocks = document.querySelectorAll('.spacer');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] spacer block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSpacer);
    } else {
        initSpacer();
    }
})();